<template>
  <div class="card assign-group-dropdown">
    <header class="card-header">
      <p class="card-header-title">
        <i class="fa fa-search"></i>
        <input type="text" class="search-input" />
      </p>
    </header>
    <div class="card-content">
      <smooth-scrollbar>
        <div class="content" style="height:200px">
          <div class="item" v-for="(group,i) in data" :key="i">
            <input
              v-model="selected"
              :id="group.uid"
              type="checkbox"
              :value="group.uid"
              class="custom-checkbox is-info is-small"
            />
            <p class="name is-medium-16-500-19">{{group.name}}</p>
          </div>
        </div>
      </smooth-scrollbar>
    </div>
    <footer class="card-footer">
      <a @click="$emit('close')" class="card-footer-item medium-weight">{{localization('app-cancel','Cancel')}}</a>
      <a @click="assign_ftg()" class="card-footer-item medium-weight">{{localization('app-assign-group','Assign Group')}}</a>
    </footer>
  </div>
</template>

<script>
import FeatureTypeGroupService from "@/services/feature-type-group.service";
import { mapState } from "vuex";
const featureTypeGroupService = new FeatureTypeGroupService();

export default {
  props: ["details"],
  data() {
    return {
      selected: [],
      data: []
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState(["container"])
  },
  methods: {
    async getData() {
      try {
        this.data = (
          await featureTypeGroupService.getAll({
            query: `pk=true&exclude_containers=${this.$route.params.uid}&org=${
              this.container ? this.container.organization : ""
            }`
          })
        ).data;
      } catch (err) {
        this.handleErrors(err);
      }
    },
    async assign_ftg() {
      try {
        await featureTypeGroupService.assign_to_view({
          id: this.$route.params.uid,
          body: {
            featureTypeGroups: this.selected
          }
        });
        this.getData();
        this.$emit("groups_added");
        this.$emit("close");
      } catch (err) {
        this.handleErrors(err);
      }
    }
  }
};
</script>
<style lang="scss">
.card.assign-group-dropdown {
  position: absolute;
  width: 88%;
  border-radius: 1rem;
  right: 30px;
  top: -5px;
  z-index: 10;
  border-radius: 10px;
  box-shadow: 0 20px 99px 0 rgba(23, 30, 72, 0.4);
  background-color: #fafcff;
  .fa-search{
    margin-left: 0.8rem;
    color:#5c617e;
  }
  .search-input {
    border: 0;
    padding: 0.5rem;
    &:active,
    &:focus {
      outline: none;
    }
  }
  .item {
    // margin-left: 0.5rem;
    text-transform: capitalize;
    font-weight: 500;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    .name {
      margin-left: 0.5rem;
      color: #171e48;
      font-size: 15px;
    }
  }
}
</style>